import React, { useState, useEffect } from 'react';

import {
  getAllStaff,
  postStaff,
  editStaff,
  deleteStaff,
} from '../../../api/services/teamApi';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminTeamMemberCard from '../../../components/admin/cards/AdminTeamMemberCard/AdminTeamMemberCard';
import TeamMemberModal from '../../../components/admin/modals/TeamMemberModal/TeamMemberModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminTeamMembers.css';

const AdminTeamMembers = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  // Team Members Admin Page
  const getAllTeamMembers = async () => {
    try {
      const teamMembers = await getAllStaff();
      setTeamMembers(teamMembers);
    } catch (err) {
      console.error('Failed to fetch team members:', err);
    }
  };

  useEffect(() => {
    getAllTeamMembers();
  }, []);

  const onAddClickHandler = () => {
    setSelectedMember({});
    setEditModalMode('add');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (member) => {
    setSelectedMember(member);
    setEditModalMode('edit');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (member) => {
    setSelectedMember(member);
    setIsDeleteModalOpen(true);

    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedMember(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedMember(null);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editModalMode === 'edit') {
        await editStaff(selectedMember._id, formData);
        alert('Success! Team member updated successfully!');
      } else {
        await postStaff(formData);
        alert('Success! Team member created successfully!');
      }

      await getAllTeamMembers();
      onModalClose();
    } catch (error) {
      console.error('Submit failed:', error);
      alert('Something went wrong.  Please try again.');
    }
  };

  const onConfirmDelete = async () => {
    try {
      await deleteStaff(selectedMember._id);
      await getAllTeamMembers();
      onDeleteModalClose();

      alert(
        `Deleted! ${selectedMember.firstName} ${selectedMember.lastName} deleted successfully!`,
      );
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete team member.');
    }
  };

  return (
    <div className='team-page-container'>
      <div className='team__page'>
        <div className='admin-team-title-add-member-container'>
          <h1 className='admin-team-members-title'>Team Members</h1>
          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={onAddClickHandler}
          >
            Add Team Member
          </ContentChangeButton>
        </div>
        <div className='team__layout'>
          {teamMembers.map((t, i) => (
            <AdminTeamMemberCard
              key={i}
              teamMember={t}
              onEditClickHandler={onEditClickHandler}
              onDeleteClickHandler={onDeleteClickHandler}
            />
          ))}
        </div>
      </div>

      {isEditModalOpen && (
        <TeamMemberModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          member={selectedMember}
          mode={editModalMode}
        />
      )}

      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle={`${selectedMember?.firstName} ${selectedMember?.lastName}`}
        />
      )}
    </div>
  );
};

export default AdminTeamMembers;
